<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<div class='mx'>
  <p-table #dt styleClass='card condensed m-none'
           [columns]='cols'
           [value]='addresses'
           class='condensed table-no-break table-full-width'
           dataKey='uuid'
           [lazy]='true' (onLazyLoad)='loadAddressesLazy($event)'
           [paginator]='true'
           [resizableColumns]='true'
           columnResizeMode='expand'
           [reorderableColumns]='true'
           [rows]='10' [totalRecords]='totalSize' data-testid="uuid-table">
    <ng-template pTemplate='header' let-columns>
      <tr>
        <th *ngFor='let col of columns' [pSortableColumn]='col.field' pResizableColumn pReorderableColumn>
          {{ col.header | translate }}
          <p-sortIcon [field]='col.field'></p-sortIcon>
        </th>
        <th style='width: 100px'>
        </th>
      </tr>
      <tr>
        <th *ngFor='let col of columns'>
          <div class='ui-column-filter'>
            <input *ngIf="col.type === 'text'" pInputText placeholder="{{'address.list.search' | translate}}"
                   type='text'
                   (input)='dt.filter($event.target.value, col.field, col.filterMatchMode)' data-testid="input">

            <p-select
              appendTo='body'
              *ngIf="col.type === 'dropdown' && col.field === 'addressTypeValue'"
              scrollHeight='300px'
              [showClear]='true'
              [style]="{width: '100%'}"
              [options]="addressType | stringToSelectItems: 'address.addressTypes' | addEmptySelectItemOption: ('address.utils.all' | translate)"
              [ngModel]='dt.filters[col.field]?.value'
              (ngModelChange)='dt.filter($event, col.field, col.filterMatchMode)' data-testid="value-select">
            </p-select>

            <p-select
              appendTo='body'
              *ngIf="col.type === 'dropdown' && col.field === 'visibilityType'"
              scrollHeight='300px'
              [style]="{width: '100%'}"
              [options]="visibilityTypes | stringToSelectItems: 'address.visibilityTypes' | addEmptySelectItemOption: ('address.utils.all' | translate)"
              [ngModel]='dt.filters[col.field]?.value'
              (ngModelChange)='dt.filter($event, col.field, col.filterMatchMode)' data-testid="value-select-2">
            </p-select>

          </div>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate='body' let-rowData let-columns='columns'>
      <tr [pSelectableRow]='rowData'>
        <td *ngFor='let col of columns'>
          <ng-container *ngIf="col.type !== 'dropdown'">
            {{ rowData[col.field] }}
          </ng-container>
          <ng-container *ngIf="col.field === 'addressTypeValue' && rowData[col.field]">
            {{ 'address.addressTypes.' + rowData[col.field] | translate }}
          </ng-container>
          <span *ngIf="col.field === 'visibilityType'">
            {{ ('address.visibilityTypes.' + rowData[col.field]) | translate }}
          </span>
        </td>
        <td class='d-inline-flex'>
          <button (click)='edit(rowData.uuid)' *ngIf='!viewOnly'
                  [disabled]='!rowData.ownedByProfile && rowData.isCompanyRequired'
                  class='mr-xs p-button-outlined'
                  icon='ui-icon-edit'
                  pButton
                  type='button' data-testid="edit-btn">
          </button>
          <div *ngIf='!viewOnly'
               pTooltip="{{'address.addressIsNotOwned' | translate}}"
               [tooltipDisabled]='rowData.ownedByProfile || crmAddress'>
            <button pButton type='button' class='p-button-text'
                    icon='ui-icon-delete'
                    [disabled]='!rowData.ownedByProfile && !crmAddress || rowData.isCompanyRequired'
                    (click)='onShowDialog(rowData.uuid)' data-testid="on-show-dialog-btn">
            </button>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-dialog header="{{'address.utils.deleteConfirmation' | translate}}"
          [(visible)]='showDialog'
          [modal]='true'
          [closable]='false'>
  <ng-template pTemplate="footer">
    <button pButton type='button' class='p-button-text' [label]="'address.utils.no' | translate"
            (click)='onHideDialog()' data-testid="on-hide-dialog-btn"></button>

    <button pButton type='button' [label]="'address.utils.yes' | translate"
            (click)='delete()' data-testid="delete-btn"></button>
  </ng-template>
</p-dialog>


